<script>
  import Clarity from "@microsoft/clarity";
  import { onMount } from "svelte";
  import { logEvent } from "../lib/firebase";
  import AppsShowCase from "./AppsShowCase.svelte";
  import BlogSection from "./BlogSection.svelte";
  import Contact from "./Contact.svelte";
  import Experience from "./Experience.svelte";
  import Hero from "./Hero.svelte";
  import Recommendation from "./Recommendation.svelte";
  import Web3Project from "./Web3Project.svelte";

  export let theme;

  let mouseX = 0;
  let mouseY = 0;

  function handleMouseMove(event) {
    mouseX = event.clientX;
    mouseY = event.clientY;
  }

  onMount(() => {
    // Use try-catch to handle any environment variable issues
    let projectId;
    try {
      projectId = import.meta.env.VITE_CLARITY_ID;
    } catch (error) {
      console.warn("Environment variables not available:", error);
      projectId = "";
    }

    if (projectId && projectId !== "" && projectId !== "undefined") {
      try {
        Clarity.init(projectId);
        console.log("Clarity initialized successfully");
      } catch (error) {
        console.error("Failed to initialize Clarity:", error);
      }
    } else {
      console.warn(
        "Clarity project ID not found or not configured. Please set VITE_CLARITY_ID in your .env file."
      );
    }

    logEvent("page_view", { page_path: "/", page_title: "Home Page" });
  });
</script>

<svelte:window on:mousemove={handleMouseMove} />

<!-- Fixed Background -->
<div
  class="fixed inset-0 bg-white dark:bg-[#0A0F1C] transition-colors duration-300"
>
  <!-- Enhanced Animated Gradients -->
  <div class="absolute inset-0">
    <div
      class="absolute top-[-20%] -left-[10%] w-[800px] h-[800px]
      bg-gradient-to-r from-blue-500/10 via-violet-500/10 to-purple-500/10 dark:from-blue-500/20 dark:via-violet-500/20 dark:to-purple-500/20 rounded-full
      mix-blend-normal blur-[150px] animate-float transform-gpu"
    ></div>
    <div
      class="absolute bottom-[-20%] -right-[10%] w-[800px] h-[800px]
      bg-gradient-to-r from-purple-500/10 via-fuchsia-500/10 to-pink-500/10 dark:from-purple-500/20 dark:via-fuchsia-500/20 dark:to-pink-500/20 rounded-full
      mix-blend-normal blur-[150px] animate-float-delayed transform-gpu"
    ></div>

    <!-- Reactive gradient that follows mouse -->
    <div
      class="absolute w-[400px] h-[400px] bg-gradient-to-r from-cyan-500/5 to-blue-500/5 dark:from-cyan-500/10 dark:to-blue-500/10
      rounded-full mix-blend-normal blur-[80px] transition-transform duration-1000 ease-out transform-gpu"
      style="transform: translate({mouseX * 0.05}px, {mouseY * 0.05}px)"
    ></div>
  </div>

  <!-- Enhanced Grid Overlay -->
  <div class="absolute inset-0">
    <div
      class="absolute inset-0 bg-[linear-gradient(to_right,#00000005_1px,transparent_1px),linear-gradient(to_bottom,#00000005_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:44px_44px]"
    ></div>
    <div
      class="absolute inset-0 bg-[linear-gradient(to_right,#00000002_1px,transparent_1px),linear-gradient(to_bottom,#00000002_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#ffffff02_1px,transparent_1px),linear-gradient(to_bottom,#ffffff02_1px,transparent_1px)] bg-[size:15px_15px]"
    ></div>
  </div>
</div>

<!-- Content -->
<main class="relative snap-y">
  <Hero bind:theme />
  <Experience />
  <AppsShowCase />
  <Web3Project />
  <BlogSection />
  <Recommendation />
  <!-- <TechStack /> -->
  <Contact />
</main>

<style>
  @keyframes float {
    0%,
    100% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(-20px, -20px);
    }
  }

  @keyframes float-delayed {
    0%,
    100% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(20px, 20px);
    }
  }

  .animate-float {
    animation: float 20s ease-in-out infinite;
  }

  .animate-float-delayed {
    animation: float-delayed 20s ease-in-out infinite;
    animation-delay: -10s;
  }
</style>
